<div class="credlix-ad-section">
  <img src="./assets/images/rsz_credlix_white_logo.png" alt="credlix_ad"
    class="credlix-ad-image img-fluid mb-3" loading="lazy">
  <span class="ad-heading">Get Credit Loan for your Tender Execution</span>
  <span class="ad-sub-heading">Get hassle free financing for your business</span>
  <a class="credlix-external-link" target="_blank"
    href="https://www.credlix.com/?utm_source=tendershark&utm_medium=homepage&utm_campaign=promotion">Know
    More</a>
  <a class="google-play-btn" target="_blank" href="https://bit.ly/4fPvRid"><img class="img-fluid w-100"
      src="./assets/images/google-play-badge-logo-svgrepo-com.webp" alt="google play image"></a>
</div>


<div class="fltr-column single-accordion mb-15">

  <div class="panel-group fltr">
    <div class="panel" [ngClass]="{'panel-open' : TenderByKeywordsAccordion[0]}">
      <div class="panel card panel-default">
        <div class="panel-heading card-header panel-enabled" (click)="TenderByKeywordsToggle(0)">
          <div class="panel-title">
            <div class="accordion-toggle">
              <button type="button" class="btn btn-link">Tenders By Keywords</button>
            </div>
          </div>
        </div>
        <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : TenderByKeywordsAccordion[0]}"
          *ngIf="TenderByKeywordsAccordion[0]">
          <div class="panel-body card-block card-body">
            <ul class="view-more-list">
              <li *ngFor="let item of visibleTenderByKeywords">
                <a (click)="navigateToTender(item.link, $event)"
                  [href]="baseUrl + '/' + item.link + '-tenders/active'">
                  {{ item?.name }} Tenders
                </a>
              </li>
            </ul>
            <a class="read-more-cta" (click)="toggleViewTenderByKeywords()">
              {{ showAllTenderByKeywords ? "View Less" : "View More" }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
<div class="fltr-column single-accordion mb-15">
  <div class="panel-group fltr">
    <div class="panel" [ngClass]="{'panel-open' : tenderByCitiesAccordion[0]}">
      <div class="panel card panel-default">
        <div class="panel-heading card-header panel-enabled" (click)="tenderByCitiesToggle(0)">
          <div class="panel-title">
            <div class="accordion-toggle">
              <button type="button" class="btn btn-link"> Tenders By Cities </button>
            </div>
          </div>
        </div>
        <div class="panel-collapse collapse" [ngClass]="{'show displayBlock' : tenderByCitiesAccordion[0]}"
          *ngIf="tenderByCitiesAccordion[0]">

          <div class="panel-body card-block card-body">
            <ul class="view-more-list">
              <li *ngFor="let item of visibleTenderByCities">
                <a (click)="navigateToTender(item.link, $event)"
                  [href]="baseUrl + '/' + item.link + '-tenders/active'">
                  {{ item?.name }} Tenders
                </a>
              </li>
            </ul>
            <a class="read-more-cta" (click)="toggleViewTenderByCities()">
              {{ showAllTenderByCities ? "View Less" : "View More" }}
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<div *ngIf="isMobileCheck" class="mt-40">
  <app-supplier-central-ads-listing-page></app-supplier-central-ads-listing-page>
</div>